import JackpotComponent from "ags/components/jackpot-component";
import TrailDisplay from "ags/components/trail-display";
import { Signal } from "signals";
import AnimateSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/animate-symbol-behaviour";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import Contract from "slotworks/utils/contracts/contract";
import Timer from "slotworks/utils/timer";
import SparkComponent from "../components/spark-component";

export default class SparkBehaviour extends AnimateSymbolBehaviour {

    public animationComplete: Signal;

    public sparkType = SparkComponent;

    protected landscapeSpark: SparkComponent;
    protected portraitSpark: SparkComponent;
    protected trailDisplay: TrailDisplay;
    protected upgradeLevel: number;

    public constructor(symbol: SymbolComponent, upgradeLevel: number, trailDisplay: TrailDisplay) {
        super(symbol);
        this.animationComplete = new Signal();
        this.upgradeLevel = upgradeLevel;
        this.trailDisplay = trailDisplay;

        canvasManager.onOrientationChange.add((orientation: Orientation) => this.switchOrientation(orientation));
    }

    public land() {
        return new Contract<void>((resolve) => {
            this.animate("_land", ["land"], true).execute();

            // Timer to ensure firework fires at the correct time in the symbol animation.
            Timer.setTimeout(() => {

                const layer = JackpotComponent.fireworksLayer;

                const doUpgrade = this.upgradeLevel >= 0;

                const landscapePosition = this.trailDisplay.getPosition(Orientation.LANDSCAPE, doUpgrade);
                const portraitPosition = this.trailDisplay.getPosition(Orientation.PORTRAIT, doUpgrade);

                this.landscapeSpark = new this.sparkType(this.symbol, landscapePosition, layer);
                this.portraitSpark = new this.sparkType(this.symbol, portraitPosition, layer);

                this.switchOrientation(canvasManager.orientation);

                this.landscapeSpark.fire().execute();

                this.portraitSpark.fire().then(() => {
                    if (doUpgrade) {
                        this.trailDisplay.upgrade(this.upgradeLevel);
                    }
                    this.trailDisplay.sparkLanded();
                });

                this.portraitSpark.onParticlesGone.addOnce(() => {
                    resolve(null);
                    if (!this.animation) {
                        this.animationComplete.dispatch();
                    } else {
                        this.animation.onComplete.addOnce(() => this.animationComplete.dispatch());
                    }
                });

            }, this.trailDisplay.landDelay + this.delay);
        });
    }

    public destroy() {
        if (this.landscapeSpark) {
            this.landscapeSpark.destroy();
            this.landscapeSpark = null;
            this.portraitSpark.destroy();
            this.portraitSpark = null;
        }
    }

    protected switchOrientation(orientation: Orientation) {
        if (this.landscapeSpark && this.portraitSpark) {
            switch (orientation) {
                case Orientation.LANDSCAPE:
                    this.landscapeSpark.setVisible(true);
                    this.portraitSpark.setVisible(false);
                    break;
                case Orientation.PORTRAIT:
                    this.landscapeSpark.setVisible(false);
                    this.portraitSpark.setVisible(true);
                    break;
            }
        }
    }
}
